import {CountryOfOriginGroup} from '../../kit/groups/CountryOfOriginGroup';
import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function VehicleRegistrationCountriesSubSection() {
  return (
    <>
      <VFKit.SubSection data-testid="vehicle-registration-countries">
        <VFKit.Group data-testid="country-fields" columns={[1, 2, 4]}>
          <CountryOfOriginGroup />
        </VFKit.Group>
      </VFKit.SubSection>
    </>
  );
}
